import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '8fr 8fr 4fr 2fr 1fr',
    paddingLeft: 12,
    color: 'grey',
    alignItems: 'center',
    borderRadius: 12,
    marginBottom: 4,
    backgroundColor: theme.palette.background.paper,
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '3fr 1fr' }
  }
}))
export default useStyles
